import { CUSTOMER_URL } from "../../constants/LocalStorageVariables";

export function getAdminUserId() {
  const userId = localStorage.getItem("PAY_PUP_LS_AUTH_USER_ID");
  return userId;
}

export function getAdminFirstName() {
  const firstName = localStorage.getItem("PAY_PUP_ADMIN_FIRSTNAME");
  return firstName;
}

export function getAdminLastName() {
  const lastName = localStorage.getItem("PAY_PUP_ADMIN_LASTNAME");
  return lastName;
}
export function getCustomeremail() {
  const email = localStorage.getItem("CUSTOMER_EMAIL");
  return email;
}
export function getAdminEmail() {
  const email = localStorage.getItem("PAY_PUP_ADMIN_EMAIL");
  return email;
}
export function getAdminPhone() {
  const phone = localStorage.getItem("PAY_PUP_ADMIN_PHONE_NUMBER");
  return phone;
}
export function getAdminProfile() {
  const phone = localStorage.getItem("PAY_PUP_ADMIN_PROFILE_IMAGE");
  return phone;
}
export function getAgencyId() {
  const agencyId = localStorage.getItem("PAY_PUP_LS_AGENCY_ID");
  return agencyId;
}

export function getDetails() {
  const data = JSON.parse(localStorage.getItem("PAY_PUP_LS_AUTH_USER_DETAILS"));
  return data;
}
export function getTemplateId() {
  const templateId = localStorage.getItem("PAY_PUP_LS_TEMPLATE_ID");
  return templateId;
}

export function getAgencyLogo() {
  const agencyLogo = localStorage.getItem("AGENCYLOGO");
  return agencyLogo;
}
export function getAuthAgencyId() {
  const agencyId = localStorage.getItem("LOGGED_AGENCY_ID");
  return agencyId;
}

export function getAgencyDelete() {
  const value = localStorage.getItem("DELETED_AGENCY");

  return value;
}

export function getCustomerToken() {
  const customerToken = localStorage.getItem("CUSTOMER_TOKEN");
  return customerToken;
}
export function getCustomerUserId() {
  const userId = localStorage.getItem("CID");
  return userId;
}
export function getCustomerAgencyId() {
  const agencyId = localStorage.getItem("CUSTOMER_AGENCY_ID");
  return agencyId;
}
export function getAgencyURL() {
  const agencyURL = localStorage.getItem("PAY_PUP_AGENCY_URL");
  return agencyURL;
}

export function getCustomerAgencyURL() {
  const cusagencyURL = localStorage.getItem("CUSTOMER_AGENCY_URL");
  return cusagencyURL;
}

export function getRole() {
  const role = localStorage.getItem("PAY_PUP_LS_AUTH_USER_ROLE");
  return role;
}

export function getRootUser() {
  const isRootUser = localStorage.getItem("PAY_PUP_IS_ROOTUSER");
  return isRootUser;
}

export function getCustomerUrl() {
  const url = localStorage.getItem(CUSTOMER_URL);
  return url;
}
export const SingleStringFirstLetterCaps = (value) => {
  return value ? value.charAt(0).toUpperCase() + value.slice(1) : "";
};
